import { render } from "./Avatar.vue?vue&type=template&id=2b55976a&ts=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=2b55976a&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__